import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// store
import { setSort, setLoading } from "../../configureStore";
//helpers
import isObjectEmpty from "../../helper/emptyObj";
// components
import Dropdown from "react-bootstrap/Dropdown";

const Sort = ({global,...props}) => {
	const dispatch = useDispatch();
	const [dropdownState, setDropdownState] = useState(global.localization.filterAZ);
	const [activeItem, setActiveItem] = useState("az");
	const searchData = useSelector((state) => state.searchData);
	const facilityList = useSelector((state) => state.facilityList);

	useEffect(() => {
		let sortType = searchData.sort;
		setActiveItem(sortType);
		setSortData(sortType);
	}, []);
	// set desktop  sort to be equal to mobile sort
	useEffect(() => {
		if (window.innerWidth < 1024) {
			let sortType = searchData.sort;
			setActiveItem(sortType);
			setSortData(sortType);
		}
	}, [searchData.sort]);
	useEffect(() => {
		if (searchData.locationChecked) {
			setActiveItem("distance");
			setDropdownState(global.localization.filterDistance);
		} else {
			const sortType = searchData.sort;
			setActiveItem(sortType);
			setDropdownState(global.localization[`filter${sortType.toUpperCase()}`]);
		}
	}, [searchData.locationChecked]);
	const setSortData = (sortType) =>{
		if (sortType === "distance") {
			setDropdownState(global.localization.filterDistance);
		} else if (sortType === "az") {
			setDropdownState(global.localization.filterAZ);
		} else {
			setDropdownState(global.localization.filterZA);
		}
	}
	const clickEvent = () => {
		props.callback(true);
	};
	const setDropdownValue = async (value, text) => {
		setDropdownState(text);
		setActiveItem(value);
		await dispatch(setSort({ value: value, action: "checked" }));
		dispatch(setLoading(true));
	};
	return (
		<div className="sorting">
			<div className="sorting-filters__label">
				{global.localization.results}
				{" : "}
				{!isObjectEmpty(facilityList) ? facilityList.facilities.length : null}
			</div>
			<div className="sorting__control">
				<Dropdown align="end">
					<Dropdown.Toggle id="dropdown-basic">
						{global.localization.sortBy}
						{dropdownState}
					</Dropdown.Toggle>
					<Dropdown.Menu
						popperConfig={{
							modifiers: [
								{
									name: "offset",
									enabled: true,
									options: {
										offset: [0, 10],
									},
								},
							],
						}}>
						<Dropdown.Item
							as="button"
							active={activeItem === "az"}
							value="az"
							onClick={(e) =>
								setDropdownValue(e.target.value, e.target.textContent)
							}>
							{global.localization.filterAZ}
						</Dropdown.Item>
						{searchData.locationChecked && (
							<Dropdown.Item
								as="button"
								active={activeItem === "distance"}
								value="distance"
								onClick={(e) =>
									setDropdownValue(e.target.value, e.target.textContent)
								}>
								{global.localization.filterDistance}
							</Dropdown.Item>
						)}
						<Dropdown.Item
							as="button"
							active={activeItem === "za"}
							value="za"
							onClick={(e) =>
								setDropdownValue(e.target.value, e.target.textContent)
							}>
							{global.localization.filterZA}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</div>
			<div className="sorting__button">
				<button
					className="button-link"
					onClick={clickEvent}>
					{global.localization.sorting}
				</button>
			</div>
		</div>
	);
};

export default Sort;
